import * as React from 'react'
import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

import { cn } from '@/lib/utils'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, error, iconLeft, iconRight, ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className="relative w-full">
      <div className="relative">
        {iconLeft && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {iconLeft}
          </div>
        )}
        <input
          type={inputType}
          className={cn(
            'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 shadow-xs shadow-input',
            iconLeft && 'pl-10',
            (iconRight || isPassword) && 'pr-10',
            className
          )}
          ref={ref}
          {...props}
          onBlur={(event) => {
            props?.onBlur?.(event);
            
          }}
        />
        {iconRight && !isPassword && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            {iconRight}
          </div>
        )}
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
          >
            {showPassword ? (
              <Eye color="hsl(var(--muted-foreground))" className="h-4 w-4" />
            ) : (
              <EyeOff color="hsl(var(--muted-foreground))" className="h-4 w-4" />
            )}
          </button>
        )}
      </div>
      {error && (
        <span className="mt-2 block text-left text-xs font-normal text-red-500">
          {error}
        </span>
      )}
    </div>
  );
}
)
Input.displayName = 'Input'

export { Input }